import _ from 'lodash';
import { createSelector } from 'reselect';

import { ContactsPresentationType } from 'constants/company';

import { getCompany } from './company.selectors';

const selectContactsPresentation = createSelector(
  getCompany,
  ({ contactsPresentation }) => contactsPresentation,
);

export const selectApplyFormSortedContactsPresentation = createSelector(
  selectContactsPresentation,
  contactsPresentation =>
    _.orderBy(
      contactsPresentation.filter(
        contact => contact.contactsPresentationType === ContactsPresentationType.APPLY_FORM,
      ),
      [({ orderNumber }) => orderNumber],
    ),
);

export const selectRealtorsSortedContactsPresentation = createSelector(
  selectContactsPresentation,
  contactsPresentation =>
    _.orderBy(
      contactsPresentation.filter(
        contact => contact.contactsPresentationType === ContactsPresentationType.REALTORS,
      ),
      [({ orderNumber }) => orderNumber],
    ),
);
